module.exports = __webpack_public_path__ + "img/auction.14513b9a.svg";